import React from 'react';
import { VEHICLE_MODELS } from 'src/enums';
import BrandAutocomplete, { createOption } from '.';

function VehicleModelAutoComplete({ onChange, value, name, multiple }) {
  return (
    <BrandAutocomplete
      label="Vehicle Type"
      placeholder="Select vehicle model..."
      onChange={onChange}
      value={value}
      name={name ?? 'model'}
      options={VEHICLE_MODELS.map((el) => createOption(el, el))}
      multiple={multiple}
    />
  );
}

export default VehicleModelAutoComplete;
